import { action, observable, runInAction } from 'mobx';

import agent from '../api/agent';
import { RootStore } from './rootStore';

export default class InformationStore {
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
  }

  @observable information: string[] = [];

  @action loadInformation = async () => {
    try {
      const information = await agent.Information.list();
      runInAction('loading Information', () => {
        this.information = information;
      });
    } catch (error) {
      runInAction('load Information error', () => {});
    }
  };
}
